var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-div-chart",style:({ height: _vm.data_height + 'px' })},[_c('chart-sub',{key:_vm.key,ref:"chart",style:('height:' + _vm.data_height + 'px;'),attrs:{"constructor-type":_vm.chartType,"options":_vm.option,"callback":_vm.created}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }